<template>
<div>
    <div v-if="Object.keys(posicaoAtual).length > 0" class="animated fadeInUp d-block d-sm-none posicao-atual-mobile" >

        <a href="#" 
            style="position: absolute;top: -20px;right: 10px;" 
            class="fechar-modal float-right" @click.prevent="$emit('fechar')">
			<fa-icon icon="times"/>
		</a>

        <div class="card-dados-voo-mobile">
            <div class="row">
                <div class="col-6 text-center">
                    <div class="informacao">{{posicaoAtual._equipamento.prefixo}} </div>
                    <small>PREFIXO</small>
                </div>
                <div class="col-6 text-center">
                    <div class="informacao">{{posicaoAtual._cliente.nome}} </div>
                    <small>CLIENTE</small>
                </div>
            </div>
            <div class="row">
                <div class="col-6 text-center">
                    <div class="informacao">{{posicaoAtual.velocidade}} Kt  </div>
                    <small>VELOCIDADE</small>
                </div>

                <div class="col-6 text-center">
                    <div class="informacao">{{posicaoAtual.direcao}}º  </div>
                    <small>DIREÇÃO</small>
                </div>

            </div>

            <div class="row">

                <div class="col-6 text-center">
                    <div class="informacao">{{posicaoAtual.altitude}} m  </div>
                    <small>ALTITUDE</small>
                </div>

                <div class="col-6 text-center">
                    <div class="informacao">{{posicaoAtual.altitudeGoogle}} m  </div>
                    <small>SOLO</small>
                </div>
            </div>

            <div class="row">
                <div class="col-6 text-center">
                    <div class="informacao">{{posicaoAtual.data}}  </div>
                    <small>DATA</small>
                </div>
                <div class="col-6 text-center">
                    <div class="informacao">{{posicaoAtual.dataUTC}}  </div>
                    <small>UTC</small>
                </div>
            </div>

            <div class="row">
                <div class="col-6 text-center">
                    <div style="margin-bottom: -6px;">{{posicaoAtual.lat}}  </div>
                    <small style="color: rgb(0, 82, 204)">LATITUDE</small>
                </div>
                <div class="col-6 text-center">
                    <div style="margin-bottom: -6px;">{{posicaoAtual.lng}} </div>
                    <small style="color: rgb(0, 82, 204)">LONGITUDE</small>
                </div>
            </div>
        </div>

        <div class="iphone-x-bottom"></div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        posicaoAtual: {
            type: Object,
            required: true,
            default: {}
        }
    }
}
</script>


<style lang="scss" scoped>

.posicao-atual-mobile {
	position:fixed; 
	bottom:0px; 
	width:100%; 
	padding:1em; 
	padding-bottom:60px; 
	background:rgba(255, 255, 255, 0.75); 
	opacity:0.8
}


.card-dados-voo-mobile {

	font-size: 0.8em;
	.row {
		margin-top:8px;
	}

	small {
		color: rgb(0, 82, 204)
	}
	
	.informacao {
		margin-bottom: -6px;
	}
}
</style>





// WEBPACK FOOTER //
// src/views/monitoramento/card-dados-voo-mobile.vue